module.exports = __webpack_public_path__ + "img/Protection.d52ac030.svg";